<template>
  <Notification
    :description="
      $t('rc_notification_new_providers', {
        ConnectivityProvider: providerName,
      })
    "
    v-bind="$attrs"
  >
    <template #ctaContent>
      <div class="tw:mt-3 tw:md:mt-0">
        <BaseLinkButton
          size="medium"
          class="tw:w-full tw:font-bold tw:text-blue-800 tw:text-nowrap"
          @click="openUpdateConnectivityProviderModal"
        >
          <span>{{ $t('notifications_cta_update') }}</span>
        </BaseLinkButton>
      </div>
    </template>
  </Notification>
</template>

<script setup>
import { computed } from 'vue'
import Notification from '@/components/productNotifications/Notification.vue'
import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'

import { useConnectivityProviderName } from '@/composables/useConnectivityProviderName'
import { useRateConnect } from '@/components/rateConnect/useRateConnect'

const props = defineProps({
  extraParameters: { type: Object, default: () => ({}) },
})
const { openUpdateConnectivityProviderModal } = useRateConnect()
const { providerName } = useConnectivityProviderName(computed(() => props.extraParameters.partnerId))
</script>
